import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import SubpageForm from "@administration/components/editor/contentForms/SubpageForm";
import ContentsTypes from "@shared/enums/contentsTypes";
import { FormTitle } from "@administration/components/editor/contentForms/ContentFormStyled";
const SubpageDynamicForm = (props) => {
    const { content, onContentChange } = props;
    const { label, children } = content;
    const subPageChild = children?.find((c) => c.type === ContentsTypes.PAGE);
    const { id } = content;
    const handleSubPageChange = (newSubpageChild) => {
        onContentChange({
            ...content,
            children: children?.map((child) => {
                if (child === subPageChild) {
                    return newSubpageChild;
                }
                return child;
            }),
        });
    };
    return (_jsxs("div", { children: [_jsx(FormTitle, { children: label }), _jsx(SubpageForm, { content: subPageChild, onContentChange: handleSubPageChange })] }, id));
};
export default SubpageDynamicForm;
